
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import IndustriesHero from './components/IndustriesHero';
import IndustrySection from './components/IndustrySection';
import FutureReadySection from './components/FutureReadySection';

const IndustriesPage = () => {
  const industries = [
    {
      title: 'Home Services',
      description: 'AI systems that improve lead response, scheduling, follow-up, dispatch efficiency, and job workflow for HVAC, plumbing, roofing, and trade-based businesses.',
      capabilities: [
        'Lead intake and qualification',
        'Smart scheduling and follow-up',
        'Operational visibility and reporting',
      ],
      icon: 'ri-home-gear-line',
      reverse: false,
      image: 'https://public.readdy.ai/ai/img_res/ebc553841032ca1d40f298a07a06f19d.jpg'
    },
    {
      title: 'Law Firms & Legal Practices',
      description: 'Intelligent intake, case qualification, follow-up automation, and operational systems built for compliance-heavy, high-trust legal environments.',
      capabilities: [
        'Lead screening and routing',
        'Intake automation',
        'Client communication workflows',
      ],
      icon: 'ri-scales-3-line',
      reverse: true,
      image: 'https://readdy.ai/api/search-image?query=Modern%20law%20firm%20office%20with%20legal%20documents%20and%20digital%20technology%20integration%20sophisticated%20professional%20environment%20dark%20elegant%20interior%20with%20emerald%20green%20accent%20lighting%20premium%20corporate%20aesthetic&width=600&height=450&seq=legal1&orientation=landscape'
    },
    {
      title: 'Med Spa, Wellness & Lifestyle',
      description: 'Patient engagement, booking optimization, reactivation, and operational automation — without sacrificing care quality or brand experience.',
      capabilities: [
        'Booking and reactivation flows',
        'Patient communication systems',
        'Experience-focused automation',
      ],
      icon: 'ri-heart-pulse-line',
      reverse: false,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20medical%20spa%20and%20wellness%20center%20interior%20with%20modern%20technology%20and%20patient%20booking%20system%20elegant%20serene%20atmosphere%20dark%20sophisticated%20design%20with%20teal%20emerald%20accent%20lighting&width=600&height=450&seq=medspa1&orientation=landscape'
    },
  ];

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <IndustriesHero />
      {industries.map((industry, index) => (
        <IndustrySection key={index} {...industry} />
      ))}
      <FutureReadySection />
      <Footer />
    </div>
  );
};

export default IndustriesPage;
